module.exports = __webpack_public_path__ + "img/mz.cb850f2d.png";